import {DataListModel} from '../interface';
import {RealEstateAgentModel} from './realEstateAgentModel';

export class RealEstateAgentsModel extends DataListModel {
  items: RealEstateAgentModel[] = [];
}
